module.exports = __webpack_public_path__ + "img/haqian.9044159f.gif";